module.exports = __webpack_public_path__ + "static/media/moreactions.22c77444.svg";